export class ApplicationCreationResult {
  applicationId: string;
  postProcessingResult: any;
  preProcessingResult: any;
}
